<div class="center"
  cy-searchResultSummary
  >
  @switch (hasProductResults()) {
    @case (true) {
      <p class="m-t-10-l m-b-15-l m-t-10-x m-b-15-x m-t-8 m-b-10 m-l-4 m-r-4"
        sizeClass="XL:h2, MS:h3"
        >
      {{"Search results for '%'" | translate : result.term}}</p>
    }
    @case (false) {
      <p class="m-t-8 m-b-9 m-t-6-m m-t-6-s m-b-3-m m-b-3-s m-l-4 m-r-4"
        sizeClass="XL:h2, MS:h3">
        {{"Sorry, we couldn't find any results for '%'" | translate : result?.term }}
      </p>
      <search-quick-links [term]="result.term "></search-quick-links>
      <icms-outlet-block name="Search Page - no results components"
      variant="search-view-page-no-results"></icms-outlet-block>
    }
  }
</div>
@if (hasProductResults()) {
  <product-listing class="wrap block"
    context="search"
    [searchResult]="result"
  [listing]="listing"></product-listing>
}

<search-banner class="wrap block m-t-10 m-b-10 m-b-5-s"
[term]="result?.term"></search-banner>